import React, { useEffect, useState } from 'react'
import { FileText } from 'lucide-react'
import MainLayout from '../../layout/MainLayout'
import { useAuth } from '../../context/AuthContext'
import { api } from '../../api/axios';
import { toast } from 'react-toastify';
import PushNotificationForm from '../../components/PushNotificationForm';



const LogsButton = ({ view, setView }) => {
    return (
        <button
            type="button"
            onClick={() => setView(view === 'form' ? 'logs' : 'form')}
            className="flex items-center gap-2 px-4 py-2 bg-green-800 text-white rounded-lg text-sm hover:bg-green-700 transition"
        >
            {
                view === 'logs' ? (
                    <>
                        <FileText size={16} />
                        <span>Send Push Notification</span>
                    </>
                ) : (
                    <>
                        <FileText size={16} />
                        <span>Push Notification Logs</span>
                    </>
                )
            }
        </button>
    )
}


export default function PushNotification() {
    const { } = useAuth();
    const [loading, setLoading] = useState(false);
    const [view, setView] = useState('form');
    const [logs, setLogs] = useState([]);

    const [form, setForm] = useState({
        title: '',
        body: '',
        userStatus: 'active',
        userType: 'all',
        linkType: 'none',
        linkId: '',
        linkUrl: '',
    });



    const fetchData = async () => {
        try {
            const res = await api.get('/push-notifications/push-logs');
            setLogs(res.data.logs);
            console.log(res.data);

        } catch (err) {
            console.log(err);
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        // Handle form submission logic here

        if (!form.title || !form.body || !form.userStatus || !form.userType) {
            return toast.error('Please fill all required fields');
        }


        try {
            setLoading(true);
            const res = await api.post('/push-notifications/send', form);
            if (res.status === 200) {
                toast.success('Push notification sent successfully');
                fetchData();
            }
        } catch (err) {
            console.error(err);
            const status = err?.response?.status;
            const detail = err?.response?.data?.error || err?.response?.data?.details || err?.message;
            toast.error(`Failed to send push notification${status ? ` (${status})` : ''}${detail ? `: ${detail}` : ''}`);

        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }

    const handleLogsFileData = async (fileName) => {
        try {
            const res = await api.get(`/push-notifications/push-logs/${fileName}`);
            return res.data;
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <MainLayout title="Push Notification"
            Buttons={<LogsButton view={view} setView={setView} />}
        >
            {
                view === 'form' && (
                    <PushNotificationForm
                        loading={loading}
                        form={form}
                        setForm={setForm}
                        handleSubmit={handleSubmit}
                    />
                )
            }


            {
                view === 'logs' && (
                    <LogsComponent
                        logs={logs}
                        handleLogsFileData={handleLogsFileData}
                    />
                )
            }

        </MainLayout>
    )
}




const LogsComponent = ({ logs, handleLogsFileData }) => {
    const [activeLog, setActiveLog] = useState(null);

    const [logContent, setLogContent] = useState('');

    useEffect(() => {
        if (activeLog) {
            handleLogsFileData(activeLog)
                .then((content) => {
                    setLogContent(content);
                });
        }
    }, [activeLog, handleLogsFileData]);


    return (
        <div className="h-[76dvh] w-full bg-white border rounded-xl shadow flex overflow-hidden m-auto">

            {/* LEFT: Logs List */}
            <div className="w-64 border-r bg-gray-50 p-4 overflow-y-auto">
                <h3 className="text-sm font-semibold mb-4 flex items-center gap-2">
                    <FileText size={16} />
                    Logs
                </h3>

                <ul className="space-y-2 text-sm">
                    {logs.map((log) => (
                        <li
                            key={log}
                            onClick={() => setActiveLog(log)}
                            className={`cursor-pointer p-2 rounded-lg transition
                                ${activeLog === log
                                    ? 'bg-blue-100 text-blue-700'
                                    : 'hover:bg-gray-200'
                                }`}
                        >
                            {log}
                        </li>
                    ))}
                </ul>
            </div>

            {/* RIGHT: Log Content */}
            <div className="flex-1 p-4 overflow-hidden">
                <h3 className="text-sm font-semibold mb-3">
                    Log Details
                </h3>

                <div className="h-[calc(76dvh-80px)] border rounded-lg bg-gray-50 p-4 overflow-y-auto">
                    {activeLog ? (
                        <pre className="text-xs whitespace-pre-wrap">
                            {logContent?.content}
                        </pre>
                    ) : (
                        <div className="h-full flex items-center justify-center text-sm text-gray-500">
                            Select a log file from the left to view details
                        </div>
                    )}
                </div>
            </div>

        </div>
    )
}

